/* specs/02-home.md — home page interactive bits */

(function () {
  // Featured collection tabs: pre-rendered panels, toggled by chip.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) return;
    const wrapper = trigger.closest('[data-featured-tabs]');
    if (!wrapper) return;
    const index = trigger.dataset.tabTrigger;

    wrapper.querySelectorAll('.chip').forEach((chip) => {
      chip.classList.remove('is-selected');
      chip.setAttribute('aria-pressed', 'false');
    });
    trigger.classList.add('is-selected');
    trigger.setAttribute('aria-pressed', 'true');

    wrapper.querySelectorAll('[data-tab-heading]').forEach((el) => {
      el.hidden = el.dataset.tabHeading !== index;
    });
    wrapper.querySelectorAll('[data-tab-panel]').forEach((el) => {
      el.hidden = el.dataset.tabPanel !== index;
    });
  });

  // Hero: add the hero product straight to the bag.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hero-add-to-bag]');
    if (!button) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    window.VelourCart.addItem(variantId, 1).catch((error) => console.error(error));
  });

  // Welcome-back strip: reorder the last order's line items, straight to checkout.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-reorder]');
    if (!button) return;
    const raw = button.dataset.items || '';
    const items = raw
      .split(',')
      .filter(Boolean)
      .map((pair) => {
        const [id, quantity] = pair.split(':');
        return { id, quantity: parseInt(quantity, 10) || 1 };
      });
    if (!items.length) return;

    button.disabled = true;
    fetch(`${window.routes.cart_add_url}.js`, { ...fetchConfig(), body: JSON.stringify({ items }) })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not reorder');
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error(error);
        button.disabled = false;
      });
  });

  // WhatsApp opt-in: the live store's chosen pattern is a customer-initiated
  // wa.me message (strongest opt-in signal, no checkout incentive needed).
  function openWhatsAppOptIn(form) {
    const input = form.querySelector('input[type="tel"]');
    const phone = input.value.replace(/\D/g, '');
    if (phone.length !== 10) {
      input.reportValidity();
      return;
    }
    const message = encodeURIComponent(
      `Hi Velour! I'd love WhatsApp updates — count me in 🤎 My number: +91${phone}`
    );
    window.open(`https://wa.me/${window.velour.whatsappNumber}?text=${message}`, '_blank', 'noopener');

    const success = form.parentElement.querySelector('[data-whatsapp-optin-success]');
    if (success) {
      success.hidden = false;
      form.hidden = true;
    }
  }

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-whatsapp-optin-form]')) {
      event.preventDefault();
      openWhatsAppOptIn(event.target);
    }
    if (event.target.matches('[data-welcome-card-form]')) {
      event.preventDefault();
      openWhatsAppOptIn(event.target);
      try {
        localStorage.setItem('velour_welcome_sample_claimed', '1');
      } catch (e) {
        /* localStorage unavailable */
      }
      const card = event.target.closest('[data-welcome-card]');
      if (card) {
        card.removeAttribute('data-open');
        setTimeout(() => card.setAttribute('hidden', ''), 300);
      }
    }
  });

  // New-visitor welcome card: once per browser, never for logged-in customers
  // (the section itself already skips rendering for logged-in customers).
  const card = document.querySelector('[data-welcome-card]');
  if (card) {
    let dismissed = false;
    try {
      dismissed =
        localStorage.getItem('velour_welcome_card_dismissed') === '1' ||
        localStorage.getItem('velour_welcome_sample_claimed') === '1';
    } catch (e) {
      dismissed = false;
    }

    if (!dismissed) {
      card.removeAttribute('hidden');
      setTimeout(() => card.setAttribute('data-open', ''), 600);
    }

    card.querySelector('[data-welcome-card-close]')?.addEventListener('click', () => {
      card.removeAttribute('data-open');
      try {
        localStorage.setItem('velour_welcome_card_dismissed', '1');
      } catch (e) {
        /* localStorage unavailable */
      }
      setTimeout(() => card.setAttribute('hidden', ''), 300);
    });
  }
})();
